// extracted by mini-css-extract-plugin
module.exports = {"width":"data_width__aLTCO","hero-text":"data_hero-text__3dpRK","wrapper":"data_wrapper__sUDyy","split":"data_split__v_JIZ"};